export enum UserTypes {
  ADD_USERID = "@@user/ADD_USERID",
  CLEAR_USERID = "@@user/CLEAR_USERID",
}

export interface UserState {
  userID: number;
  reseller: boolean;
}
